import React from 'react';
import { BorderedButton } from '../../commonComponents/BorderedButton/BorderedButton';
import { RedButton } from '../../commonComponents/RedButton/RedButton';
import { PopupWrapper } from '../../commonComponents/PopupWrapper/PopupWrapper';
import styles from './index.module.sass';
import { ClosePopupButton } from '../../commonComponents/ClosePopupButton/ClosePopupButton';

export function CounterWarning({ handleSubmit, onClose, data }) {
  const handleClosePopupButtonClick = () => {
    onClose(null);
  };

  const submitForm = () => {
    handleSubmit(data.id, {
      onSettled: () => handleClosePopupButtonClick(),
    });
  };

  return (
    <>
      <PopupWrapper />
      <section className={styles.create_form}>
        <ClosePopupButton handleClosePopupButtonClick={handleClosePopupButtonClick} />
        <h2 className={styles.create_form__title}>
          <b>WARNING!</b>
        </h2>
        <div className={styles.flex_container}>
          <form className={styles.form}>
            <label className={styles.form__label}>
              <span>
                Resetting the video completion status will <b>decrease the count</b> in both the{' '}
                <b>Team Contest</b> and <b>Team Completion Status</b>.
              </span>
            </label>
            <br />
            <p className={styles.form__importance}>This action cannot be reversed.</p>
            <div className={styles.buttons}>
              <BorderedButton
                handleButtonClick={handleClosePopupButtonClick}
                width={'20rem'}
              ></BorderedButton>
              <RedButton handleButtonClick={submitForm} title={`Reset`} width={'20rem'}></RedButton>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
